<template>
  <layout-section-header
    :title="$t('advertiser_configuration')"
    :has-trigger="false"
  />

  <magic-container class="mt-4">
    <form novalidate class="d-flex" xs6 @submit.prevent="submit">
      <v-text-field
        class="transition-width"
        v-model="name"
        :label="$t('name')"
        type="text"
        :error-messages="nameErrors"
        :hide-details="false"
      />
      <transition name="fade">
        <span v-if="isChanged">
          <v-btn
            class="ml-6"
            color="primary"
            @click="cancelEdit()"
            :disabled="isLoading"
            icon
            density="compact"
            width="40"
            height="40"
            variant="outlined"
            :title="$t('cancel_changes')"
          >
            <v-icon class="material-icons-outlined">close</v-icon>
          </v-btn>

          <v-btn
            class="ml-2"
            color="primary"
            type="submit"
            :disabled="isLoading"
            icon
            density="compact"
            width="40"
            height="40"
            variant="outlined"
            :title="$t('save_changes')"
          >
            <v-icon class="material-icons-outlined">done</v-icon>
          </v-btn>
        </span>
      </transition>
    </form>
    <div class="d-flex justify-space-between" xs6>
      <span class="advertiser-info">
        <div>{{ $t('activity') }}</div>
        {{ $t('view_reports_in_metabase') }}
      </span>
      <v-btn
        :href="metabaseLink"
        target="_blank"
        color="primary"
        variant="outlined"
      >
        <v-icon>open_in_new</v-icon>
        {{ $t('open_metabase') }}
      </v-btn>
    </div>
  </magic-container>
</template>

<script>
import { required } from '@vuelidate/validators';
import { isObj } from '@/utils';
import { useVuelidate } from '@vuelidate/core'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    advertiser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: this.advertiser.name,
      originalName: this.advertiser.name,
      isLoading: false,
    };
  },
  validations: {
    name: {
      required,
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.v$.name.$dirty) return errors;
      !this.v$.name.required && errors.push(this.$t('required'));
      return errors;
    },
    isChanged() {
      return this.name !== this.originalName;
    },
    metabaseLink() {
      return import.meta.env.VUE_APP_TRACKING_METABASE_URL + this.advertiser.name;
    },
  },
  watch: {
    advertiser: {
      handler(nextAdvertiser) {
        if (isObj(nextAdvertiser)) {
          this.name = nextAdvertiser.name;
          this.originalName = nextAdvertiser.name;
        }
      },
      deep: true,
    },
  },
  methods: {
    cancelEdit() {
      this.name = this.originalName;
    },
    submit() {
      if (this.isLoading || !this.isChanged) return;

      this.v$.$touch();
      if (this.v$.$invalid) return;
      this.isLoading = true;
      this.$store.dispatch('tracking/updateAdvertiser', {
        id: this.advertiser.id,
        name: this.name,
      })
      .then(() => {
        this.v$.$reset();
        this.originalName = this.name;
      })
      .catch((err) => err)
      .finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.advertiser-info {
  display: flex;
  font-size: 12px;
  flex-direction: column;
  margin-right: 16px;

  div {
    font-size: 14px;
    font-weight: bold;
  }
}

.transition-width {
  transition: width 0.3s ease;
}
</style>
